module.exports = __webpack_public_path__ + "img/bitcoin.1ee1227e.svg";